"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthContractMinutesCell = void 0;
const react_1 = __importDefault(require("react"));
const util_1 = require("@app/util");
const sort_by_1 = require("../../sort-by");
const format_hours_1 = require("@app/util/format-hours");
const no_known_value_1 = require("./no-known-value");
const Cell = ({ monthContractMinutes }) => (react_1.default.createElement("td", null,
    react_1.default.createElement("span", { className: 'no-arrow' }),
    (0, format_hours_1.formatHours)(util_1.timeUtil.asHour(monthContractMinutes))));
const MonthContractMinutesCell = ({ sortData, monthContractMinutes, multipleContracts, multiplePositions, multipleLocalities, }) => {
    if ((0, util_1.isUndefined)(sortData)) {
        return (react_1.default.createElement(Cell, { monthContractMinutes: monthContractMinutes }));
    }
    if (sortData.sortedBy === sort_by_1.SORT_BY.CONTRACT && !multipleContracts) {
        return (react_1.default.createElement(Cell, { monthContractMinutes: monthContractMinutes }));
    }
    if (sortData.sortedBy === sort_by_1.SORT_BY.POSITION && !multiplePositions) {
        return (react_1.default.createElement(Cell, { monthContractMinutes: monthContractMinutes }));
    }
    if (sortData.sortedBy === sort_by_1.SORT_BY.LOCALITY && !multipleLocalities) {
        return (react_1.default.createElement(Cell, { monthContractMinutes: monthContractMinutes }));
    }
    // if (sortData.sortedBy === SORT_BY.CONTRACT) {
    //   const _monthContractMinutes = monthContractMinutesByContract.find((contract) => contract.contractType === sortData.id)?.minutes ?? 0
    //   return (
    //     <Cell monthContractMinutes={_monthContractMinutes} />
    //   )
    // }
    // Render default once again just in case
    return (react_1.default.createElement(no_known_value_1.NoKnownValue, null));
};
exports.MonthContractMinutesCell = MonthContractMinutesCell;
